var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnquiryIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.571,
    height: 20,
    viewBox: "0 0 28.571 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "solid_money-check",
    "data-name": "solid money-check",
    d: "M0,50.571A1.429,1.429,0,0,0,1.429,52H27.143a1.429,1.429,0,0,0,1.429-1.429V36.286H0Zm20-9.286a.714.714,0,0,1,.714-.714H25a.714.714,0,0,1,.714.714v1.429a.714.714,0,0,1-.714.714H20.714A.714.714,0,0,1,20,42.714Zm0,5.357a.357.357,0,0,1,.357-.357h5a.357.357,0,0,1,.357.357v.714a.357.357,0,0,1-.357.357h-5A.357.357,0,0,1,20,47.357ZM2.857,42.357A.357.357,0,0,1,3.214,42H16.786a.357.357,0,0,1,.357.357v.714a.357.357,0,0,1-.357.357H3.214a.357.357,0,0,1-.357-.357Zm0,4.286a.357.357,0,0,1,.357-.357h7.857a.357.357,0,0,1,.357.357v.714a.357.357,0,0,1-.357.357H3.214a.357.357,0,0,1-.357-.357ZM27.857,32H.714A.714.714,0,0,0,0,32.714v2.143H28.571V32.714A.714.714,0,0,0,27.857,32Z",
    transform: "translate(0 -32)",
    fill: "#fc1"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnquiryIcon);
export default __webpack_public_path__ + "static/media/enquiry-icon.abfb59b52d3c174243c115cc66cc6d93.svg";
export { ForwardRef as ReactComponent };